import { isArray, isObject } from "../utils/utils";

export function convertStyle(style: {}) {
    if (!isObject(style)) {
        return style;
    }

    const result = Object.keys(style).reduce((converted, key) => {
        converted[kebabToCamel(key)] = style[key];
        return converted;
    }, {});

    return result;
}

export function classes(...args: (string | string[] | {})[]) {
    const classes = args.map((classes) => {
        if (isArray(classes)) {
            return classes.filter((c) => !!c).join(" ");
        }

        if (!isObject(classes)) {
            return classes as string;
        }

        return Object.keys(classes)
            .filter((k) => classes[k])
            .join(" ");
    });

    return classes.filter((c) => !!c).join(" ");
}

export function classesWithPrefix(prefix: string): typeof classes {
    return (...args) => classes(...args.map((x) => (typeof x === "string" ? `${prefix}--${x}` : x)));
}

function kebabToCamel(string: string) {
    return string.replace(/-([^-])/g, (g) => g[1].toUpperCase());
}
